import { render } from "./ModalAddUpdateFlashingAppliance.vue?vue&type=template&id=552cc232"
import script from "./ModalAddUpdateFlashingAppliance.vue?vue&type=script&lang=js"
export * from "./ModalAddUpdateFlashingAppliance.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__